import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  iconUploadContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 6,
    paddingBottom: 6,
  },
  multiselectTitle: {
    zIndex: 1000,
  },
  iconPreview: { maxWidth: 200, maxHeight: '100%' },
  tootlTipUsers: {
    backgroundColor: '#1265591A',
    border: '1px solid #275E56',
    padding: '16px',
    borderRadius: '10px',
    color: '#275E56',
  },
  outlinedMultiSelect: {
    paddingTop: '10px',
    '& .dropdown-container': {
      border: 'none',
      position: 'relative',
      paddingTop: '6px',
      paddingBottom: '7px',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
        transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        pointerEvents: 'none',
      },
      '&:hover:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
      '&:focus-within': {
        boxShadow: 'none !important',
      },
      '&:focus-within:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
    },
  },
})

export { useStyles }
